import React from 'react'
import { ToolbarOptionLink, ToolbarOptionLinkExterno } from '@monorepo-amais/commons/components/Navbar/styled'

// custom icons

import MenuResultadoExames from '@monorepo-amais/commons/components/Icons/ResultadoExames'

import ChatIcon from '@monorepo-amais/commons/components/Icons/Chat'

//SVG pro componente HomeOnly

import SVGChat from '@monorepo-amais/commons/Icons/chat.svg'

import SVGResultado from '@monorepo-amais/commons/Icons/menu-resultado.svg'

import SVGResultadoWhite from '@monorepo-amais/commons/Icons/menu-resultado-white.svg'

import SVGChatWhite from '@monorepo-amais/commons/Icons/chat-white.svg'

import theme from '../../theme'
//array de itens dos menus
const setMenuItens = (isClient, urlResults) => {
	const menuItens = [
		{
			text: 'Resultado de Exames',
			href: urlResults, //pagina pra navegacao pra fora do site
			target: '_blank',
			to: '', //pagina pra navegacao dentro do site
			as: ToolbarOptionLinkExterno, //tema pro menu desk
			icon: <MenuResultadoExames theme={theme} isClient={isClient} />, //icon pro menu desk
			svg: isClient ? SVGResultado : SVGResultadoWhite, //svg pro menu mobile HomeOnly
			showMobileHome: true, //flag pra filtrar os itens da home do mobile
			showMobile: true, //flag pra filtrar os itens do menu hamburguer do mobile
			showDesk: true //flag pra filtrar os itens do desk
		},
		{
			text: 'Ouvidoria',
			href: '',
			target: '',
			to: '/fale-conosco/',
			as: ToolbarOptionLink,
			icon: (
				<ChatIcon
					theme={theme}
					isClient={isClient}
					color={isClient ? null : '#FFFFFF'}
					style={{ transform: 'scale(0.8)' }}
				/>
			),
			svg: isClient ? SVGChat : SVGChatWhite,
			showMobileHome: true,
			showMobile: true,
			showDesk: true
		}
	]

	return menuItens
}

export default setMenuItens
